export const ListA = [
  'passport',
  'passport_card',
  'permanent_resident_card',
  'foreign_passport_i551',
  'employment_authorization_document',
  'foreign_passport_i94',
  'fsm_rmi_passport',
] as const

export const ListB = [
  'drivers_license',
  'state_id',
  'local_government_id',
  'school_id_card',
  'voter_registration_card',
  'military_card',
  'military_dependent_id',
  'coast_guard_merchant_mariner',
  'native_american_tribal',
  'canadian_drivers_license',
] as const

export const ListC = [
  'social_security_card',
  'certification_of_birth',
  'birth_certificate',
  'native_american_tribal_c',
  'us_citizen_id_card',
  'resident_citizen_id_card',
  'dhs_employment_authorization',
] as const

export const Supplementary = ['other'] as const

export const documentTypes = [
  ...ListA,
  ...ListB,
  ...ListC,
  ...Supplementary,
] as const
export type DocumentType = (typeof documentTypes)[number]

export const DocumentTitles: Record<DocumentType, string /** Document Name */> =
  {
    birth_certificate: 'Birth Certificate',
    canadian_drivers_license: "Canadian Driver's License",
    certification_of_birth: 'Certification of Report of Birth',
    coast_guard_merchant_mariner: 'U.S. Coast Guard Merchant Mariner Card',
    dhs_employment_authorization: 'Employment Authorization Document (DHS)',
    drivers_license: "Driver's License",
    employment_authorization_document:
      'Employment Authorization Document (Form I-766)',
    foreign_passport_i551: 'Foreign Passport with I-551 Stamp',
    foreign_passport_i94: 'Foreign Passport with I-94/I-94A',
    fsm_rmi_passport: 'FSM/RMI Passport with I-94/I-94A',
    local_government_id: 'Local Government ID',
    military_card: 'U.S. Military Card',
    military_dependent_id: "Military Dependent's ID Card",
    native_american_tribal_c: 'Native American Tribal Document',
    native_american_tribal: 'Native American Tribal Document',
    passport_card: 'Passport Card',
    passport: 'Passport',
    permanent_resident_card: 'Permanent Resident Card (Form I-551)',
    resident_citizen_id_card:
      'Identification Card for Resident Citizen (Form I-179)',
    school_id_card: 'School ID Card',
    social_security_card: 'Social Security Card - not DHS/INS restricted',
    state_id: 'State ID',
    us_citizen_id_card: 'U.S. Citizen ID Card (Form I-197)',
    voter_registration_card: "Voter's Registration Card",
    other: 'Other',
  }

export const Passport = [
  'passport',
  'foreign_passport_i551',
  'foreign_passport_i94',
  'fsm_rmi_passport',
] satisfies DocumentType[]
